/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCodePackageTypeLookup.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/code-package-type-lookup";

export class AutogenModelCodePackageTypeLookup<RowType extends ModelRow> extends Endpoint<RowType, RowCodePackageTypeLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCodePackageTypeLookup extends ModelRow<RowCodePackageTypeLookupFields> {
	constructor(values?: Partial<RowCodePackageTypeLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCodePackageTypeLookupFields {
	add_timestamp: Date;
	add_userid: string;
	company_id: string;
	edi_standard_code: string;
	field_code: string;
	field_code_desc: string;
	field_name: string;
	field_table_alias: string;
	mod_timestamp: Date;
	mod_userid: string;
}

